import React from "react";
import { Card, Typography, Row, Col, Button } from "antd";
import styled from "styled-components";

const { Title, Text } = Typography;

// Styled components for KD-farger
const SectionContainer = styled.div`
  background-color: var(--neutral-alt);
  padding: 5em 6em;
  min-height: 100vh;
`;

const StyledCard = styled(Card)`
  background: var(--neutral);
  border-radius: var(--border-radius);
  text-align: center;
  padding: 2em;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledButtonContainer = styled.div`
  margin-top: 1.5em;
`;

const StyledButton = styled(Button)`
  background: var(--primary-color);
  color: white;
  border: none;
  &:hover {
    background: var(--secondary-color);
    color: black;
  }
`;

const SummerInternshipPage: React.FC = () => {
  return (
    <SectionContainer>
      {/* Overskrift */}
      <Row justify="center" style={{ textAlign: "center", marginBottom: "3em" }}>
        <Col span={16}>
          <Title style={{ color: "var(--primary-color)" }} level={2}>
            Summer Internship Presentasjoner
          </Title>
          <Text style={{ fontSize: "18px", color: "var(--font-color-alt)" }}>
            Utforsk spennende internship-muligheter presentert av ulike bedrifter.
          </Text>
        </Col>
      </Row>

      {/* Kort-seksjon (tre på rad) */}
      <Row gutter={[32, 32]} justify="center">
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <StyledCard>
            <Title level={4}>Summer Internship Presentasjoner - Tirsdag</Title>
            <Text>Kom og hør hvilke muligheter det finnes hos tirsdagens bedrifter!</Text>
            <StyledButtonContainer>
              <StyledButton>Les mer</StyledButton>
            </StyledButtonContainer>
          </StyledCard>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <StyledCard>
            <Title level={4}>Summer Internship Presentasjoner - Onsdag</Title>
            <Text>Kom og hør hvilke muligheter det finnes hos onsdagens bedrifter!</Text>
            <StyledButtonContainer>
              <StyledButton>Les mer</StyledButton>
            </StyledButtonContainer>
          </StyledCard>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <StyledCard>
            <Title level={4}>Summer Internship Presentasjoner - Torsdag</Title>
            <Text>Kom og hør hvilke muligheter det finnes hos torsdagens bedrifter!</Text>
            <StyledButtonContainer>
              <StyledButton>Les mer</StyledButton>
            </StyledButtonContainer>
          </StyledCard>
        </Col>
      </Row>
    </SectionContainer>
  );
};

export default SummerInternshipPage;
